import ClassesTaughtModule from './containers/classesTaughtModule'

export {default as ClassesTaughtModuleLayout} from './components/classesTaughtModuleLayout'

export default ClassesTaughtModule
